/**
 * Utilidades de color hexadecimal para los selectores del Diseñador.
 *
 * `normalizarHex` acepta lo que una persona escribe o pega: con o sin "#", en mayúsculas o minúsculas,
 * con espacios alrededor, de 6 dígitos (#RRGGBB) o de 3 (#RGB, que se expande: #1a9 -> #11aa99).
 * Devuelve siempre "#rrggbb" en minúsculas (el mismo formato que entrega el selector visual del navegador y
 * que ya guardan los diseños) o null si no es un color válido. No acepta nombres de color, rgb() ni
 * transparencia (8 dígitos): el lienzo y la impresión trabajan con colores sólidos.
 */
export const normalizarHex = (texto) => {
  if (typeof texto !== 'string') return null;
  const t = texto.trim().replace(/^#/, '');
  if (/^[0-9a-fA-F]{6}$/.test(t)) return `#${t.toLowerCase()}`;
  if (/^[0-9a-fA-F]{3}$/.test(t)) return `#${t.split('').map((c) => c + c).join('').toLowerCase()}`;
  return null;
};

/** ¿Lo escrito hasta ahora todavía puede llegar a ser un hex válido? (solo "#" y hasta 6 dígitos hex). */
export const esPrefijoDeHex = (texto) => typeof texto === 'string' && /^\s*#?[0-9a-fA-F]{0,6}\s*$/.test(texto);
